'use client';

/**
 * HubSpot Cart Redirect Component
 *
 * Client component that checks for ?cart= parameter and redirects to /cart/hubspot
 * This handles the HubSpot quote cart flow where users click links with cart data
 */

import { useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import { Loader2 } from 'lucide-react';

function HubSpotCartRedirectContent() {
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Check for HubSpot cart parameter
    const cartParam = searchParams.get('cart');
    if (cartParam) {
      // Redirect to HubSpot cart handler with the cart data
      router.replace(`/cart/hubspot?cart=${encodeURIComponent(cartParam)}`);
    }
  }, [searchParams, router]);

  // If cart param exists, show loading overlay while redirecting
  const cartParam = searchParams.get('cart');
  if (cartParam) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white">
        <Loader2 className="h-12 w-12 animate-spin text-blue-500 mb-4" />
        <h1 className="text-xl font-semibold">Loading your quote...</h1>
      </div>
    );
  }

  // No cart param - render nothing
  return null;
}

export function HubSpotCartRedirect() {
  return (
    <Suspense fallback={null}>
      <HubSpotCartRedirectContent />
    </Suspense>
  );
}
